import { __makeTemplateObject } from "tslib";
import styled from "styled-components";
export var CustomIcon = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  background-color: ", ";\n  background: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  margin: ", ";\n  padding: ", ";\n  text-align: ", ";\n  text-transform: ", ";\n  width: ", ";\n  display: ", ";\n  flex-direction: ", ";\n  align-items: ", ";\n  gap: ", ";\n  border-radius: ", ";\n  border: none;\n  cursor: ", ";\n"], ["\n  color: ", ";\n  background-color: ", ";\n  background: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  margin: ", ";\n  padding: ", ";\n  text-align: ", ";\n  text-transform: ", ";\n  width: ", ";\n  display: ", ";\n  flex-direction: ", ";\n  align-items: ", ";\n  gap: ", ";\n  border-radius: ", ";\n  border: none;\n  cursor: ", ";\n"])), function (_a) {
    var _b = _a.$color, $color = _b === void 0 ? "black" : _b;
    return $color;
}, function (_a) {
    var _b = _a.$backgroundColor, $backgroundColor = _b === void 0 ? "inherit" : _b;
    return $backgroundColor;
}, function (_a) {
    var _b = _a.$background, $background = _b === void 0 ? "" : _b;
    return $background;
}, function (_a) {
    var _b = _a.$fontSize, $fontSize = _b === void 0 ? "16px" : _b;
    return $fontSize;
}, function (_a) {
    var _b = _a.$fontWeight, $fontWeight = _b === void 0 ? "normal" : _b;
    return $fontWeight;
}, function (_a) {
    var _b = _a.$margin, $margin = _b === void 0 ? "0" : _b;
    return $margin;
}, function (_a) {
    var _b = _a.$padding, $padding = _b === void 0 ? "0" : _b;
    return $padding;
}, function (_a) {
    var _b = _a.$textAlign, $textAlign = _b === void 0 ? "left" : _b;
    return $textAlign;
}, function (_a) {
    var _b = _a.$textTransform, $textTransform = _b === void 0 ? "none" : _b;
    return $textTransform;
}, function (_a) {
    var _b = _a.$width, $width = _b === void 0 ? "inherit" : _b;
    return $width;
}, function (_a) {
    var _b = _a.$display, $display = _b === void 0 ? "flex" : _b;
    return $display;
}, function (_a) {
    var _b = _a.$flexDirection, $flexDirection = _b === void 0 ? "column" : _b;
    return $flexDirection;
}, function (_a) {
    var _b = _a.$alignItems, $alignItems = _b === void 0 ? "unset" : _b;
    return $alignItems;
}, function (_a) {
    var _b = _a.$gap, $gap = _b === void 0 ? "2rem" : _b;
    return $gap;
}, function (_a) {
    var _b = _a.$borderRadius, $borderRadius = _b === void 0 ? "8px" : _b;
    return $borderRadius;
}, function (_a) {
    var _b = _a.$cursor, $cursor = _b === void 0 ? "pointer" : _b;
    return $cursor;
});
var templateObject_1;
